import { env } from "./env";

export const isStaging =
  env.appEnv === "development" ||
  ["dev", "localhost"].some((value) =>
    globalThis.location.host.startsWith(value)
  );

// List of feature flags.
// Example: export const FLAG_NAME = isStaging;
export const FLAG_AUDIO_MINI_PLAYER = true;
export const FLAG_PLAYLIST_SUMMARY = isStaging;
export const FLAG_SHARE_URL_ITEM = isStaging;
